import { languageHelper } from "../../../../config/helperFunctions";


import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function RiderReport() {
  const [columns] = useState([
    {
      header: languageHelper("SN"),
      accessorKey: "SN",
    },

    {
      header: languageHelper("Date"),
      accessorKey: "Date",
    },
    {
      header: languageHelper("Reference"),
      accessorKey: "Reference",
    },
    {
      header: languageHelper("Name"),
      accessorKey: "Name",
    },
    {
      header: languageHelper("Phone"),
      accessorKey: "Phone",
    },
    {
      header: languageHelper("G. Total"),
      accessorKey: "G. Total",
    },
    {
      header: languageHelper("Order status"),
      accessorKey: "Order status",
    },
    {
      header: languageHelper("Payment Status"),
      accessorKey: "Payment Status",
    },
    
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: languageHelper("Submit"),
    },
  ]);

  const [selectButton] = useState([
    {
      placeholder: "Rider",
    },
  ]);
  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Rider Report")}
        buttonDataa={buttonDataa}
        selectButton={selectButton}
      />
    </main>
  );
}

export default RiderReport;
